// Uncomment and add your PROD Company API KEY to visualize Prod properties

// set at build time: .env for `start:dev`, .env.production for the builds, .env.dev on top of it for the dev deploy
export const baseUrl = process.env.REACT_APP_ENDPOINT_URL as string;
export const headers: Record<string, string> = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    // PROD KEY
    Authorization: "Token [COMPANY API KEY]",
};

export const qmsUrl = "https://qms.handiscover.com/";

export async function fetchAndParse<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
    const response = await fetch(input, init)
    // any 2xx is a success, not only 200
    if (!response.ok) {
        let json: string | null = null;
        try {
            json = await response.json();
        } catch (e) {

        }
        // eslint-disable-next-line no-throw-literal
        throw {
            status: response.status,
            statusText: response.statusText,
            response,
            json,
        };
    }
    // 204 No Content has no body to parse
    if (response.status === 204) {
        return undefined as unknown as T;
    }
    const data = await response.json();
    return data as T;
}

export type BasicQuerySearch = {
    limit?: number;
    offset?: number;
    /**
     * Search can be either include `name` field or `id`
     */
    search?: string;
    ordering?: "name" | "created_date" | "id",
}


export type QueryParams = Record<string, string | number | boolean | null | undefined>

// "?a=1&b=2" with encoded values, the params without a value left out; "" without any
export function generateQueryString(params: QueryParams) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
        }
    });
    const queryString = searchParams.toString();
    return queryString ? `?${queryString}` : ''
}
